import React, {useState, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Loader from "../../components/Loader";
import {gsap, Power3} from "gsap";
import Helmet from "react-helmet";
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom";
import MovieInfo from "./MovieInfo";
import TvInfo from "./TvInfo";


const Container = styled.div`
    margin-top: 60px;
    height: calc(100vh - 60px);
    width: 100%;
    position: relative;
    padding: 40px 100px;
    visibility: hidden;
`;

const Content = styled.div`
    display: flex;
    width: 100%;
    position: relative;
    z-index: 0;
    height: 100%;
    gap: 50px;
`;


const Cover = styled.div`
    width: 33%;
    min-width: 300px;
    height: 100%;
    background-image: url(${props => props.bgImage});
    background-position: center center;
    background-size: cover;
    border-radius: 10px;
`;


const Backdrop = styled.div`
    position: absolute;
    top: 0;
    left:0;
    width:100%;
    height: 100%;
    background-image: url(${props => props.bgImage});
    background-position: center center;
    background-size: cover;
    filter: blur(1.5px);
`;

const Data = styled.div`
    width: 60%;
    margin-left: 10px;
    position: relative;
    overflow: hidden;

`;

const Title = styled.div`
    font-size: 32px;
    margin-bottom: 20px;
    overflow: hidden;
`;

const ItemContainer = styled.div`
    margin-bottom: 20px;
    padding: 10px 0;
    overflow: hidden;
    display: flex;

`;


const Item = styled.div`
    transform: translateY(0);
`;

const Divider = styled.span`
    margin: 0 10px;
`;

const Overview = styled.div`
    font-size: 15px;
    color: rgba(255,255,255, 0.8);
    line-height: 1.8;
    width: 60%;
    overflow: hidden;
;`;

const Slink = styled.a`
        background: rgba(20, 20, 20, 1);
        line-height: 2px;
        padding: 2px 4px;
        border-radius: 2px;
        border: 2.5px solid orange;
`;

const UlList = styled.ul`

`;

const Info = styled.div`
    position: absolute;
    bottom: 20px;
    left: 0;
    
    
`;








const DetailPresenter = ({result, error, loading, isMovie}) => {
    let con = useRef(null);
    let co = useRef(null);
    let title = useRef(null);
    let item = useRef(null);
    let infof = useRef(null);
   
    
    useEffect(() => {
        gsap.to(con.current, {css:{visibility: "visible"}})
        gsap.timeline().from(con.current, {opacity: 0, duration: 3, ease: Power3.easeOut}, 'Start')
        .from(co.current, {y: 800,opacity: .5, duration: 1.5, ease: Power3.easeOut}, .2);

        gsap.timeline().from(title.current, {y: 100, duration: 2, ease:Power3.easeOut}, 0.5)
        .from(".title", {css:{transform: "translateY(200px)"} , opacity: 0, duration: 2, ease: Power3.easeOut, stagger: {each: 0.2}},0.6)
        .from(item.current, {y: 700, duration: 2, ease: Power3.easeOut},1.5)
        .from(infof.current, {y: 700, opacity: 0, duration: 2, ease: Power3.easeOut},1.8)
    })
    return (
        loading ? 
            <>
            <Loader />
            <Helmet>
                <title>loading...</title>
            </Helmet>
            </>
          : 
            (
                <Container ref={con}>
                    <Helmet>
                    <title>{result.title ? result.title : result.original_name} | DainFlix</title>
                </Helmet>
                    <Backdrop bgImage={`https://image.tmdb.org/t/p/original/${result.backdrop_path}`} />
                    <Content>
                        <Cover ref={co} bgImage={result.poster_path ? `https://image.tmdb.org/t/p/original/${result.poster_path}` : require("../../assets/blank.png").default} />
                        <Data>
                            <Title >
                                    <div ref={title}>{result.title ? result.title : result.original_name}</div>
                                </Title>
                            <ItemContainer>
                                <Item className="title">{(result.release_date ? result.release_date : result.last_air_date).substring(0,4)}</Item>
                                <Divider className="title">•</Divider>
                                <Item className="title">{result.runtime ? result.runtime : (result.episode_run_time ? result.episode_run_time[0] : "")} min</Item>
                                <Divider className="title">•</Divider>
                                <Item className="title">{result.genres.map((genre, index) => index === result.genres.length - 1 ? genre.name : `${genre.name} / `)} </Item>
                                <Divider className="title">·</Divider>
                                <Item className="title"> 
                                        <Slink href={`https://www.imdb.com/title/${result.imdb_id}`} target="_blank">IMDB</Slink>
                                </Item>
                                
                                
                            
                            </ItemContainer>
                            <Overview>
                                <div ref={item}>
                                {result.overview}
                                </div>
                            </Overview>
                            <Info ref={infof}>
                            {isMovie ? <MovieInfo result={result} /> : <TvInfo result={result} />}
                            </Info>
                        </Data>
                    </Content>
                </Container>
            
            )
    )
    
}
// const DetailPresenter = ({result, error, loading}) => loading ? (
//     <Loader />
// )   : (
//         <Container>
//             <Backdrop bgImage={`https://image.tmdb.org/t/p/original/${result.backdrop_path}`} />
//             <Content>
//                 <Cover ref={el => test = el} bgImage={`https://image.tmdb.org/t/p/original/${result.poster_path}`} />
//                 <Data>
//                     <Title></Title>
                    
//                 </Data>
//             </Content>
//         </Container>

// )
  
    


DetailPresenter.prototype = {
    result: PropTypes.object,
    error: PropTypes.bool.isRequired,
    loading: PropTypes.string
}


export default DetailPresenter;